import {
  Component,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges,
} from "@angular/core";
import { Subscription } from "rxjs";
import { WorkflowService } from "../../service/workflow.service";
import { WfDataSignal } from "./s09-workflow.models";

@Component({
  selector: "app-s09-data-signals",
  templateUrl: "./s09-data-signals.component.html",
  styleUrls: ["./s09-workflow.scss"],
  standalone: false,
})
export class S09DataSignalsComponent implements OnInit, OnChanges, OnDestroy {
  @Input() brandKey: number | null = 200104;

  items: WfDataSignal[] = [];
  loading = false;
  hint = "";
  private loadedOnce = false;

  private subs: Subscription[] = [];

  constructor(private workflowService: WorkflowService) {}

  ngOnChanges(ch: SimpleChanges): void {
    if (ch["brandKey"]) {
      this.loadedOnce = true;
      this.reload();
    }
  }

  ngOnInit(): void {
    if (!this.loadedOnce) this.reload();
  }

  ngOnDestroy(): void {
    this.subs.forEach((s) => s.unsubscribe());
  }

  reload(): void {
    const brand = Number(this.brandKey) || 0;
    if (!brand) {
      this.items = [];
      this.hint = "No brand selected.";
      return;
    }
    this.loading = true;
    this.hint = "";
    const sub = this.workflowService.getDataSignals(brand).subscribe((rows) => {
      this.loading = false;
      this.items = rows || [];
      if (!this.items.length) {
        this.hint =
          "No data signals for this brand. Run 09_create_data_signal_config.sql and 10_seed_data_signals.sql.";
      }
    });
    this.subs.push(sub);
  }
}
